<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="渠道名称" prop="channelName">
        <el-input
          v-model="queryParams.channelName"
          placeholder="请输入渠道名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['biz:Channel:add']"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['biz:Channel:edit']"
        >修改</el-button>
      </el-col>
<!--      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['biz:Channel:remove']"
        >删除</el-button>
      </el-col>-->
<!--      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['biz:Channel:export']"
        >导出</el-button>
      </el-col>-->

      <el-col :span="1.5">
        <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="generateChannelDay14"
            v-hasPermi="['biz:ChannelDay:add']"
        >生成安排</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="channelList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="序号" align="center" prop="id" />
      <el-table-column label="渠道名称" align="center" prop="channelName" />
      <el-table-column label="渠道介绍" align="center" prop="channelIntro" />
      <el-table-column align="center" label="图片" prop="channelPic" >
        <template slot-scope="scope">
          <img style="width: 50px;height: 50px" :src="scope.row.channelPic">
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="2"
              @change="handleStatusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="默认单价" prop="channelPrice" />
      <el-table-column label="创建时间" align="center" prop="createDate" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['biz:Channel:edit']"
          >修改</el-button>
<!--          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['biz:Channel:remove']"
          >删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改预约渠道对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="医生名称" prop="channelName">
          <el-input v-model="form.channelName" placeholder="请输入渠道名称" />
        </el-form-item>
        <el-form-item label="医生介绍" prop="channelIntro">
          <el-input v-model="form.channelIntro" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="医生图片" prop="channelPic">
          <image-upload v-model="form.channelPic" :limit="1"/>
        </el-form-item>
        <el-form-item label="默认单价" prop="channelPrice">
          <el-input v-model="form.channelPrice" placeholder="请输入渠道单价" />
        </el-form-item>
        <el-form-item label="展示排序" prop="weight">
          <el-input v-model="form.weight" placeholder="请输入数字 1表示第一位 2表示第二" />
        </el-form-item>
        <el-form-item label="工作日" prop="workWeek">
          <el-select v-model="form.workWeek" :style="{width: '100%'}" clearable multiple
                     placeholder="请选择下拉选择">
            <el-option v-for="(item, index) in weekIndexOptions" :key="index" :disabled="item.disabled"
                       :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作时间段" prop="workWeek">
          <el-select v-model="form.workTimeBlockSegment" :style="{width: '100%'}" clearable multiple
                     placeholder="请选择下拉选择">
            <el-option v-for="(item, index) in workTimeBlockSegmentOptions" :key="index" :disabled="item.disabled"
                       :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
                v-for="item in upDownStatusList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addChannel, delChannel, getChannel, listChannel, updateChannel} from "@/api/biz/Channel";
import {addChannelDay} from "@/api/biz/ChannelDay";
// 读取公共枚举
import {getEnumByClassFullName} from "@/api/biz/common";
import {updateSurvey} from "@/api/biz/Survey";

export default {
  name: "Channel",
  data() {
    return {
      weekIndexOptions: [{
        "label": "周一",
        "value": "1"
      }, {
        "label": "周二",
        "value": "2"
      }, {
        "label": "周三",
        "value": "3"
      }, {
        "label": "周四",
        "value": "4"
      }, {
        "label": "周五",
        "value": "5"
      }, {
        "label": "周六",
        "value": "6"
      }, {
        "label": "周日",
        "value": "0"
      }],
      workTimeBlockSegmentOptions: [
          {
            "label": "08:00~09:00",
            "value": "1"
          },
        {
          "label": "09:00~10:00",
          "value": "2"
        },
        {
          "label": "10:00~11:00",
          "value": "3"
        },
        {
          "label": "11:00~12:00",
          "value": "4"
        },
        {
          "label": "13:00~14:00",
          "value": "5"
        },
        {
          "label": "14:00~15:00",
          "value": "6"
        },
        {
          "label": "15:00~16:00",
          "value": "7"
        },
        {
          "label": "16:00~17:00",
          "value": "8"
        },
      ],
      upDownStatusList: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 预约渠道表格数据
      channelList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        channelName: null,
        channelIntro: null,
        channelPic: null,
        status: null,
        channelPrice: null,
        createDate: null
      },
      // 表单参数
      form: {
        workWeek: ["0","1","2","3","4","5","6"],
        workTimeBlockSegment: ["1","2","3","4","5","6","7","8"],
        status : 1
      },
      // 表单校验
      rules: {
        workWeek: [{
          required: true,
          type: 'array',
          message: '请至少选择一个工作日',
          trigger: 'change'
        }],
        workTimeBlockSegment: [{
          required: true,
          type: 'array',
          message: '请至少选择一个时间段',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: '医生的状态',
          trigger: 'change'
        }],
        channelIntro: [{
          required: true,
          message: '医生的介绍',
          trigger: 'change'
        }],
        channelPic: [{
          required: true,
          message: '医生的图片',
          trigger: 'change'
        }],
        channelPrice: [{
          required: true,
          message: '医生的单价',
          trigger: 'change'
        }],
      }
    };
  },
  created() {
    //this.getUpDownStatusEnum();
    this.getList();
  },
  methods: {
    handleStatusChange(row) {
      let text = row.status == "1" ? "启用" : "停用";
      this.$modal.confirm('确认要"' + text + '""' + row.channelName + '"吗？').then(function() {
        return updateChannel(row)
      }).then(() => {
        this.$modal.msgSuccess(text + "成功");
      }).catch(function() {
        row.status = row.status === 1 ? 2 : 1;
      });
    },

    getUpDownStatusEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.UpDownStatusEnum").then(res => {
        this.upDownStatusList = res.data;
      })
    },
    /** 查询预约渠道列表 */
    getList() {
      this.loading = true;
      listChannel(this.queryParams).then(response => {
        this.channelList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        channelName: null,
        channelIntro: null,
        channelPic: null,
        status: 1,
        channelPrice: null,
        createDate: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加预约渠道";
    },
    generateChannelDay14() {
      if(this.ids.length > 1) {
        this.$modal.msgWarning("只能选择一个医生");
      }
      const id = this.ids[0]
      this.$modal.confirm('是否确认为该医生生成14天的排班计划？').then(function() {
        return addChannelDay({"channelId":id});
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("生成成功");
      }).catch(() => {});
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getChannel(id).then(response => {
        this.form = response.data;
        this.form.workWeek = response.data.workWeek.split(',');
        this.form.workTimeBlockSegment = response.data.workTimeBlockSegment?.split(',');
        this.open = true;
        this.title = "修改预约渠道";
      });
    },
    /** 提交按钮 */
    submitForm() {
      if (this.form.workWeek == "" || this.form.workTimeBlockSegment == "") {
        this.$modal.msgWarning("工作日和时间块必选");
        return;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.workWeek = this.form.workWeek.join(",");
          this.form.workTimeBlockSegment = this.form.workTimeBlockSegment.join(",");
          if (this.form.id != null) {
            updateChannel(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addChannel(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除预约渠道编号为"' + ids + '"的数据项？').then(function() {
        return delChannel(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biz/channel/export', {
        ...this.queryParams
      }, `channel_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
